var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVision(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.965 82.0082C29.403 82.0082 13.6011 71.727 5.80021 55.205C3.39993 50.0844 3.39993 43.9637 5.80021 38.8031C13.6011 22.2812 29.403 12 46.965 12C64.5271 12 80.3289 22.2812 88.1698 38.8431C90.6101 43.9637 90.6101 50.0844 88.1698 55.205C80.3689 71.727 64.6071 82.0082 46.965 82.0082ZM46.965 18.0007C31.7233 18.0007 18.0416 26.9617 11.2408 41.3634C9.56065 44.8838 9.56065 49.0843 11.2408 52.6447C18.0416 67.0464 31.7633 76.0075 46.965 76.0075C62.1668 76.0075 75.9284 67.0464 82.7292 52.6447C84.4094 49.1243 84.4094 44.9238 82.7292 41.4034C75.8884 26.9617 62.2068 18.0007 46.965 18.0007Z",
    fill: "#03182F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8449 68.3664C58.0462 68.3664 67.1272 59.2853 67.1272 48.084C67.1272 36.8827 58.0462 27.8016 46.8449 27.8016C35.6436 27.8016 26.5625 36.8827 26.5625 48.084C26.5625 59.2853 35.6436 68.3664 46.8449 68.3664Z",
    fill: "#FFC730"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6049 60.0452C39.8842 60.0452 34.3635 54.5645 34.3635 47.8438C34.3635 41.123 39.8442 35.6423 46.6049 35.6423C53.3657 35.6423 58.8464 41.123 58.8464 47.8438C58.8464 54.5645 53.3657 60.0452 46.6049 60.0452ZM46.6049 41.603C43.1645 41.603 40.3642 44.4034 40.3642 47.8038C40.3642 51.2041 43.1645 54.0045 46.6049 54.0045C50.0453 54.0045 52.8457 51.2041 52.8457 47.8038C52.8457 44.4034 50.0453 41.603 46.6049 41.603Z",
    fill: "#03182F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVision);
export default __webpack_public_path__ + "static/media/vision.5abd69bdd9084abbcd8cf9391f7a4c81.svg";
export { ForwardRef as ReactComponent };